// extracted by mini-css-extract-plugin
export var addToCartButton = "_qn-b";
export var arrowButtonContainer = "_qn-9";
export var arrowButtonIcon = "_qn-a";
export var carouselArrowButton = "_qn-6";
export var carouselElementContainer = "_qn-1";
export var left = "_qn-7";
export var productDisplayCarouselContainer = "_qn-0";
export var productTileContainer = "_qn-2";
export var productTileImage = "_qn-4";
export var productTileImageContainer = "_qn-3";
export var productTileTitle = "_qn-5";
export var right = "_qn-8";
export var sliderOverflow = "_qn-c";